import React from "react";

interface FurnitureTypeCardProps {
  title: string;
  icon: React.ReactNode;
  onSelect: () => void;
  disabled?: boolean;
}

export const FurnitureTypeCard: React.FC<FurnitureTypeCardProps> = ({
  title,
  icon,
  onSelect,
  disabled = false,
}) => {
  return (
    <div
      className={`border  rounded-lg p-4 flex flex-col items-center h-full transition-colors ${
        disabled ? "opacity-60 cursor-not-allowed" : "cursor-pointer"
      }`}
      onClick={disabled ? undefined : onSelect}
    >
      <div className="mb-3">{icon}</div>
      <h3 className="text-base font-medium text-emerald-800">{title}</h3>
    </div>
  );
};
